/**
 * Flashlight Bridge
 * 
 * Controls device flashlight/torch.
 * UNAVAILABLE on web - no browser API for flashlight control.
 */

import { UnavailableBridge } from '../BaseBridge'

export class FlashlightBridge extends UnavailableBridge {
  readonly bridgeName = 'Flashlight'
  readonly featureName = 'Flashlight'
  readonly methods = ['turnOn', 'turnOff', 'toggle', 'isOn']
}

